/** Fills `{{name}}` placeholders in a label the server already translated,
 *  for values only known on the client: a count, a score, a model name. */
export const fillLabel = (template: string, args: Record<string, string | number>): string =>
  template.replace(/\{\{(\w+)\}\}/g, (_match, name: string) => String(args[name] ?? ''))
